import React, { Component } from 'react';
import './EmailEditor.css';
import Input from 'components/shared/input/Input';
import addSvg from 'images/add.svg';
import removeSvg from 'images/remove.svg';
import Button from 'components/shared/button/Button';
import TextArea from 'components/shared/input/TextArea';
import Dropdown from 'components/shared/dropdown/Dropdown';
import PropTypes from 'prop-types';
import ImageButton from 'components/shared/button/ImageButton';
import { validateEmail } from 'services/utils/text-util';

export class EmailEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customEmail: '',
      customEmailValid: true,
      customSubject: props.subject,
      customSubjectInputEnable: false,
      userEmailOptionSelected: null,
    };
  }

  static propTypes = {
    message: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
    toEmails: PropTypes.arrayOf(PropTypes.string),
    usersEmail: PropTypes.arrayOf(PropTypes.string),
    onCustomEmailAdd: PropTypes.func,
    onMessageChange: PropTypes.func.isRequired,
    onSubjectConfirm: PropTypes.func,
    onToEmailRemove: PropTypes.func,
    onUserEmailAdd: PropTypes.func,
  };

  static defaultProps = {
    toEmails: [],
    usersEmail: [],
  };

  handleToEmailRemove = (email) => {
    if (this.props.onToEmailRemove) {
      this.props.onToEmailRemove(email);
    }
  };

  handleCustomEmailChange = (value) => {
    this.setState({
      customEmail: value,
    });
  };

  handleCustomEmailAdd = () => {
    if (validateEmail(this.state.customEmail)) {
      if (this.props.onCustomEmailAdd) {
        this.props.onCustomEmailAdd(this.state.customEmail);
      }
      this.setState({
        customEmail: '',
        customEmailValid: true,
      });
    } else {
      this.setState({
        customEmailValid: false,
      });
    }
  };

  handleUserEmailChange = (option) => {
    this.setState({
      userEmailOptionSelected: option,
    });
  };

  handleUserEmailAdd = () => {
    if (this.props.onUserEmailAdd) {
      this.props.onUserEmailAdd(this.state.userEmailOptionSelected.label);
    }
    this.setState({
      userEmailOptionSelected: null,
    });
  };

  handleSubjectClick = () => {
    if (this.state.customSubjectInputEnable && this.props.onSubjectConfirm) {
      this.props.onSubjectConfirm(this.state.customSubject);
    }
    this.setState({
      customSubjectInputEnable: !this.state.customSubjectInputEnable,
    });
  };

  handleSubjectChange = (value) => {
    this.setState({
      customSubject: value,
    });
  };

  render() {
    return (
      <div className="email-editor">
        <table>
          <colgroup>
            <col />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <td className="body-bold">To</td>
              <td>
                <div className="ee-to-emails-container">
                  {this.props.toEmails.map((email, index) => {
                    return (
                      <div key={index}>
                        <div>{email}</div>
                        <div>
                          <ImageButton
                            alt="remove"
                            src={removeSvg}
                            onClick={this.handleToEmailRemove.bind(this, email)}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </td>
            </tr>
            <tr>
              <td />
              <td>
                <div className="ee-custom-email-container">
                  <div>
                    <Input
                      placeholder="Email"
                      valid={this.state.customEmailValid}
                      value={this.state.customEmail}
                      onChange={this.handleCustomEmailChange}
                    />
                    <Button
                      className="button-orange"
                      disabled={this.state.customEmail === ''}
                      label="Add"
                      onClick={this.handleCustomEmailAdd}
                    />
                  </div>
                  {!this.state.customEmailValid && (
                    <div className="invalid-message">
                      Please verify email address.
                    </div>
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td />
              <td>
                <div className="ee-users-email-container">
                  <Dropdown
                    options={this.props.usersEmail
                      .filter(
                        (email) =>
                          this.props.toEmails.find(
                            (toEmail) => toEmail === email
                          ) === undefined
                      )
                      .map((email, index) => {
                        return {
                          value: index,
                          label: email,
                        };
                      })}
                    placeholder=""
                    value={
                      this.state.userEmailOptionSelected !== null
                        ? this.state.userEmailOptionSelected.value
                        : null
                    }
                    onChange={this.handleUserEmailChange}
                  />
                  <ImageButton
                    alt="add"
                    disabled={this.state.userEmailOptionSelected === null}
                    src={addSvg}
                    onClick={this.handleUserEmailAdd}
                  />
                </div>
              </td>
            </tr>
            <tr className="with-border">
              <td className="body-bold">Subject</td>
              <td>
                <div className="ee-subject-container">
                  {!this.state.customSubjectInputEnable ? (
                    <div className="body-bold subject">
                      {this.state.customSubject}
                    </div>
                  ) : (
                    <Input
                      value={this.state.customSubject}
                      onChange={this.handleSubjectChange}
                    />
                  )}
                  <Button
                    className="button-gray"
                    disabled={
                      this.state.customSubjectInputEnable &&
                      this.state.customSubject === ''
                    }
                    label={
                      this.state.customSubjectInputEnable
                        ? 'Confirm Subject'
                        : 'Edit Subject'
                    }
                    onClick={this.handleSubjectClick}
                  />
                </div>
              </td>
            </tr>
            <tr className="with-border">
              <td className="body-bold message">Message</td>
              <td>
                <TextArea
                  value={this.props.message}
                  onChange={this.props.onMessageChange}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/email/EmailEditor.js